import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container } from "reactstrap";
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    UncontrolledTooltip,
    Badge,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
  } from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from '../../helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import Select from 'react-select';
import FileSaver from 'file-saver';



    const LeaveRequestsPosted = () => {
      const history = useHistory();

      toastr.options = TOAST_OPTIONS;

      const [costCenters, setCostCenters] = useState([]);
      useEffect(() => {
        axios.get(url.COST_CENTERS, HRConfig).then(function(response){
          setCostCenters(response.data.value)
        })
      }, []);
      const cOptions = [{label: 'All', value:''}];
      costCenters.map((cCenter, key) => {
        cOptions.push({ label: cCenter.Code, value:cCenter.Code});
      } );
      
      const [leaveRequests, setLeaveRequests] = useState([]);
      
      useEffect(() => {
        let obj = JSON.parse(localStorage.getItem("authMildUser"));
        let EmployeeNo = obj.uid;
         axios.get(`${url.LEAVE_REQUESTS}?$filter=employeeNo eq '${EmployeeNo}' and status eq 'Approved' &company= '${obj.activeCompany}'`, HRConfig).then(function(response){
          setLeaveRequests(response.data.value);
        })
      }, []);

      const handleFilter = (e) => {
          e.preventDefault();
          let obj = JSON.parse(localStorage.getItem("authMildUser"));
          let EmployeeNo = obj.uid;
          let url = url.POSTED_LR;
          const dateRange = document.getElementsByClassName('filterDate')[0]._flatpickr.selectedDates;
          const startDate = formatDate(dateRange[0]);
          const endDate = formatDate(dateRange[1]);
          const stat = document.getElementsByClassName('filterStatus')[0].value;
          
          let urlParams = '';
      
          if(stat != ''){
            urlParams = urlParams.concat( ` and status eq '${stat}' `);
          }
 
          if(dateRange.length > 0){
            urlParams = urlParams.concat(` and ( From_Date ge ${startDate} and To_Date le ${endDate} )`);
          }
          url += `?$filter=Employee_No eq '${EmployeeNo}'`
          if(urlParams != ''){
            url += urlParams;
          }
          axios.get(url, HRConfig).then(function(response){    setLeaveRequests(response.data.value);    })
      }
      const handleStatusChanged = () => {
        const stat = document.getElementsByClassName('filterStatus')[0].value;
        stat != 'Approved' ? history.push("/leave-requests") : ""
      }
      const handleDownload = async (No) => {
        const data = {no:No}
        axios.post(url.PRINTLEAVE, JSON.stringify(data), HRConfig).then((r)=>{
          const urlx = process.env.REACT_APP_APACHE_URL + r.data.value
          //console.log(r.data)
          fetch(urlx)
            .then(response => {
              // Create a blob from the response data
              return response.blob();
            })
            .then(blob => {
              // Create a download link element
              const url = window.URL.createObjectURL(new Blob([blob]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'Report.pdf');

              // Append the link to the document body and click it to start the download
              document.body.appendChild(link);
              link.click();
              link.remove();
            })
            .catch(error => {
              console.log('Error downloading file: ', error);
            });
          /*
          axios({ urlx, method: 'GET', responseType: 'blob'}).then((x)=>{
            FileSaver.saveAs(response.data, 'document.pdf');
          }).catch((y)=>console.log(y))
          */
        }).catch((e)=>{
          console.log(e)
        })
        /*
        try {
          const response = await axios({
            url,
            method: 'GET',
            responseType: 'blob',
          });
          FileSaver.saveAs(response.data, 'document.pdf');
        } catch (error) {
          console.error(error);
        }
        */
      }


      

      const { SearchBar } = Search;
      const columns = [
      {
        dataField: 'no',
        text: 'Leave No',
        sort: true,
        formatter: noFormatter
      },
      {
        dataField: 'employeeNo',
        text: 'Employee No',
        sort: true
      }, 
      {
        dataField: 'employeeName',
        text: 'Name',
        sort: true
      }, 
      {
        dataField: 'departmentCode',
        text: 'Department Code',
        sort: true
      }, 
      {
        dataField: 'postingDate',
        text: 'Posting Date',
        sort: true
      }, 
      {
        dataField: 'status',
        text: 'Status',
        sort: true,
        formatter: statusFormatter
      },{
        dataField: 'action',
        text: 'Action',
        sort: true,
        formatter: actionFormatter
      }
    ];

      const defaultSorted = [{
        dataField: 'no',
        order: 'desc'
      }];

      function noFormatter(cellContent, row){
        return(
          <strong>{cellContent}</strong>
        )
      }
      function actionFormatter(cellContent, row){
        // return(
        //   <Button
        //     className="btn-sm btn-rounded"
        //     target="_blank"
        //     onClick={()=>{ handleDownload(row.No) }}
        //     >
        //     View Report
        // </Button>

        // )
        return(
          <>
              <div className="d-flex gap-3">
              <UncontrolledDropdown direction="left">
                  <DropdownToggle href="#" className="card-drop" tag="i">
                    <i className="mdi mdi-dots-horizontal font-size-18" />
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem
                      onClick={()=>{ history.push(`/leave-request-details/${row.SystemId}`); }}
                    >
                      <i className="fas fa-address-card text-warning me-1" />
                      Leave Request Details
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </>
          )
      }
      function statusFormatter(cellContent, row) {
        if (row.status == "Pending") {
          return (
            <div>
                <Badge className="me-2 bg-danger">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.status == "Approved"){
          return (
            <div>
                <Badge className="me-2 bg-success">
                { cellContent }
                </Badge>
            </div>
          );
        }else{
          return (
            <div>
                <Badge className="me-2 bg-warning">
                { cellContent }
                </Badge>
            </div>
          );
        }
      }

        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Posted Leave Requests | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Posted Leave Requests" />
                        
                        
                        <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <CardTitle className="h5 mb-4">Filter Leave Requests</CardTitle>
                              <Form className="row gy-2 gx-3 align-items-center" onSubmit={handleFilter}>
                                <Row>
                                <Col lg={8}>
                                <div className="col-sm-auto">
                                    <Flatpickr
                                      className="form-control d-block filterDate"
                                      placeholder="dd M,yyyy"
                                      options={{
                                        mode: "range",
                                        dateFormat: "Y-m-d"
                                      }}
                                    />
                                </div>
                                </Col>
                                
                                {/* <Col lg={3}>
                                <div className="col-sm-auto">
                                  <label className="visually-hidden" htmlFor="autoSizingSelect">By Status</label>
                                  <select defaultValue="0" className="form-select filterStatus" onChange={handleStatusChanged}>
                                    <option value=""> Select Status </option>
                                    <option value="">All</option>
                                    <option value="Open">Open</option>
                                    <option value="Approved">Approved</option>
                                    <option value="Pending Approval">Pending Approval</option>
                                  </select>
                                </div>
                                </Col> */}
                                <Col lg={4}>
                                <div className="col-sm-auto">
                                  <button type="submit" className="btn btn-primary w-md">Filter</button>
                                </div>
                                </Col>
                              
                                </Row>
                              </Form>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>                
                    <Row>
          

            <Col lg={12}>
              <Card>
                <CardBody>
                   {leaveRequests && (leaveRequests.length > 0) && (
                    <ToolkitProvider
                      keyField="No"
                      data={ leaveRequests }
                      columns={ columns }
                      search
                    >
                      { toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                               
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                
                              <div className="table-responsive">

                                <BootstrapTable 
                                  keyField='No' 
                                  data={ leaveRequests } 
                                  columns={ columns } 
                                  striped
                                  hover
                                  condensed
                                  bordered={ false }
                                  noDataIndication="No Records" 
                                  defaultSorted={ defaultSorted }
                                  classes={ "table-sm align-middle table-wrap table-check" }
                                    {...toolkitProps.baseProps}
                                  />
                                  </div>
                             
                             </Col>
                             </Row>
                             </React.Fragment>
                            
                      )
                    }
                  </ToolkitProvider>
                  )}
                  {leaveRequests && (leaveRequests.length < 1) && (
                    <div className="text-center">
                      <div className="mb-4">
                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                      </div>
                      <div>
                      <h5>No Leave Request Found</h5>
                      <p className="text-muted">
                              
                      </p>
                      </div>
                  </div>

                  )}
                </CardBody>
              </Card>
            </Col>

            

          </Row>

                    </Container>
                </div>
            </>
        );
    }

export default LeaveRequestsPosted;